import { Injectable } from '@angular/core';
import { ApiClientService } from '../api-client.service';

import {map} from 'rxjs/operators';
import {Response} from '@angular/http';
import {ICondoManagerBuildingFolder} from '../../types/api-response/condomanager/building-folder';
import {Observable} from 'rxjs/Observable';
import {ICondoManagerImport} from '../../types/api-response/condomanager/import';

@Injectable()
export class CondomanagerApiService {

    constructor(private api: ApiClientService) {
    }

    getBuildingFolders(): Observable<{ entities: ICondoManagerBuildingFolder[], total: number }> {
        const url = `/v1/building-folder?per-page=1000`;

        return this.api.get('domainCondomanager', url).pipe(
            map((response: Response) => response.json())
        );
    }

    synchronizeFolder(folderId: string): Observable<ICondoManagerImport> {
        const url = `/v1/building-folder/${folderId}/synchronize`;

        return this.api.post('domainCondomanager', url);
    }

    getListImport(buildingId): Observable<{entities: ICondoManagerImport[], total: number }> {
        const url = `/v1/import?bdId=${buildingId}`;

        return this.api.get('domainCondomanager', url).pipe(
            map((response: Response) => response.json())
        )
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/api/condomanager-api.service.ts